<template>
    <el-dialog title="Send Files"
               closeable
               :visible.sync="visible"
               :close-on-click-modal="false"
               :close-on-press-escape="false"
               :modal-append-to-body="true"
               :append-to-body="true"
               @close="close"
               width="50%"
    >
        <el-form size="medium" label-width="120px">
            <el-form-item label="Files">
                <div>
                    <div class="file-item" v-for="(f,i) in files" :key="f.id">
                        <a>{{ f.name }}</a>
                        <span class="el-icon el-icon-delete" @click="files.splice(i,1)"></span>
                    </div>
                </div>
                <el-button size="small" icon="el-icon-plus" @click="$refs.selectFiles.open()">Add Files</el-button>
            </el-form-item>
            <el-form-item label="Subject">
                <el-input v-model="options.subject" class="w500" placeholder="Subject" clearable/>
            </el-form-item>
            <el-form-item label="Mail Template">
                <el-select v-model="options.mail_template_id" placeholder="Select template">
                    <el-option
                        v-for="item in templateList"
                        :key="item.id"
                        :label="item.name"
                        :value="item.id">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="Mail From">
                <el-select v-model="options.mail_account_id" placeholder="Select mail">
                    <el-option
                        v-for="item in configList"
                        :key="item.id"
                        :label="item.from_name"
                        :value="item.id">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="CC">
                <el-input v-model="options.cc" class="w500" placeholder="CC" clearable/>
            </el-form-item>
            <el-form-item label="BCC">
                <el-input v-model="options.bcc" class="w500" placeholder="BCC" clearable/>
            </el-form-item>

            <el-form-item>
                <el-button type="primary" @click="onSend">Send</el-button>
            </el-form-item>
        </el-form>
        <dialog-select-files ref="selectFiles" @confirm="onSelectedFiles"/>
    </el-dialog>
</template>

<script>
import ApiService from "../utils/ApiService";
import DialogSelectFiles from "./DialogSelectFiles.vue";

export default {
    name: "DialogSendFile",
    components: {DialogSelectFiles},
    data() {
        return {
            visible: false,
            templateList: [],
            configList: [],
            options: {
                mail_template_id: null,
                mail_account_id: null,
                subject: null,
                cc: null,
                bcc: null,
            },
            files: []
        }
    },
    methods: {
        open() {
            this.visible = true;
        },
        close() {
            this.visible = false;
        },
        fetchTemplateList() {
            ApiService.get('/buildium/mail-templates').then(response => {
                this.templateList = response.data.items;
            }).catch(reason => {
                this.$message.error(reason.message);
            });
        },
        fetchConfigList() {
            ApiService.get('/buildium/mail-configs').then(response => {
                this.configList = response.data.items;
            }).catch(reason => {
                this.$message.error(reason.message);
            });
        },
        onSend() {
            const options = this.options;
            if (!options.subject) {
                this.$message.error('Subject is required');
                return;
            }

            if (!options.mail_template_id) {
                this.$message.error('Mail template is required');
                return;
            }

            if (!options.mail_account_id) {
                this.$message.error('Mail account is required');
                return;
            }
            this.$emit('send', {
                options,
                files: this.files
            });
            this.close();
        },
        onSelectedFiles(files) {
            files.forEach(f => {
                if (!this.files.some(f2 => f2.id === f.id)) {
                    this.files.push(f);
                }
            });
        }
    },
    mounted() {
        this.fetchTemplateList();
        this.fetchConfigList();
    }
}
</script>

<style lang="scss" scoped>
.file-item {
    line-height: 1.5 !important;

    &:hover {
        color: #409eff;
    }
}
</style>